/*global page*/
var FakeCation = window.FakeCation || {};

(function (fc) {
  "use strict";

  const NAME = 'create';
  var pageManager = fc.pageManager;

  var currentPage = pageManager.Page.create(NAME, '/' + NAME, '#' + NAME);

  currentPage.html = `<h1><img src="/assets/app/logo.svg" id="logo"></h1><div class="content"><p class="upper">Snap it like it’s hot</p><div id="selfie_button"><img src="/assets/app/photobutton1.png"></div><input type="file" accept="image/*" capture="camera">`;

  currentPage.eventHandlers = [{
    event:'click',
    target:'#selfie_button',
    handler: function () {
      var input = this.$$('input[type="file"]');
      fc.ga('/camera_click');
      fc.fbq('Camera Click');
      input.click();
    }
  },{
    event:'change',
    target:'input[type="file"]',
    handler: function(e){
      var input = e.target,
          canvas = document.createElement('canvas');

      fc.utils.input2canvas(input, canvas, 600, 600, function(){
        fc.appState.selfie = canvas.getContext('2d').getImageData(0,0,canvas.width, canvas.height);
        console.log('redirect to process');
        fc.ga('/photo_received');
        page('/process');
      });
    }
  }];

  currentPage.run = function () {
    fc.appState.selfie = null;
  };

  if (!fc.utils.webRTCSupported) {
    pageManager.add(currentPage);
  }

}(FakeCation));
